import React, { useEffect, useMemo, useState } from "react";
import { mediaCandidates } from "../../lib/catalog";

export default function CatalogImage({
  folder,
  fileName,
  alt = "",
  height = 220,
  className = "",
}) {
  const sources = useMemo(() => mediaCandidates(folder, fileName), [folder, fileName]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [folder, fileName]);

  const src = index >= 0 ? sources[index] : "";
  const wrapStyle = height == null || height === "auto" ? undefined : { height };

  return (
    <div className={`catalog-image-wrap ${className}`.trim()} style={wrapStyle}>
      {src ? (
        <img
          key={src}
          src={src}
          alt={alt}
          loading="lazy"
          referrerPolicy="no-referrer"
          onError={() => {
            setIndex((current) => {
              if (current < 0) return current;
              return current + 1 < sources.length ? current + 1 : -1;
            });
          }}
        />
      ) : (
        <span>No image</span>
      )}
    </div>
  );
}
